import box from '~/assets/icons/box_3.svg';
import busStation from '~/assets/icons/bus_station.svg';
import job from '~/assets/icons/job.svg';
import passenger from '~/assets/icons/passenger.svg';
import pizzaBox from '~/assets/icons/pizza_box.svg';
import washCar from '~/assets/icons/wash_car.svg';
import { ProgressIcon } from '~/shared';

const notificationIcons: Record<ProgressIcon, string> = {
	[ProgressIcon.Job]: job,
	[ProgressIcon.Passenger]: passenger,
	[ProgressIcon.WashCar]: washCar,
	[ProgressIcon.BusStation]: busStation,
	[ProgressIcon.Box]: box,
	[ProgressIcon.PizzaBox]: pizzaBox,
};

export const getProgressIcon = (icon: ProgressIcon) => {
	return notificationIcons?.[icon];
};
